import type { OnChangeFn, SortingState } from '@tanstack/react-table';
import { useMemo } from 'react';
import type { ExplorerSort, ExplorerSortBy } from '../../../server/utils/explorer-utils.ts';
import { ExplorerSortOrder, validSorts } from '../../../server/utils/explorer-utils.ts';

export function useExplorerSorting(
    sortingFilter: ExplorerSort | null,
    setSortingFilter: (sortingFilter: ExplorerSort | null) => void,
) {
    const sorting = useMemo(() => {
        if (sortingFilter) {
            return [
                {
                    id: sortingFilter.field,
                    desc: sortingFilter.direction === ExplorerSortOrder.DESC,
                },
            ];
        } else {
            return [];
        }
    }, [sortingFilter]);

    const sortChangedInInterface: OnChangeFn<SortingState> = (sortingState) => {
        const newState =
            typeof sortingState === 'function' ? (sortingState([]) as SortingState) : sortingState;

        if (newState.length > 0) {
            const values = newState[0];
            if (values) {
                const isValidSortBy = validSorts.includes(values.id as ExplorerSortBy);
                if (isValidSortBy) {
                    setSortingFilter({
                        field: values.id as ExplorerSortBy,
                        direction: values.desc ? ExplorerSortOrder.DESC : ExplorerSortOrder.ASC,
                    });
                }
            }
        } else {
            setSortingFilter(null);
        }
    };

    return { sorting, sortChangedInInterface };
}
